export default "__VITE_ASSET__uNWFifR0__"